import React from 'react';
import './DoorPage.css';

import { PageTitle, Heading, Style } from '../../../components';
import { doorFaqs, doorIntro, doors } from '../../../constants';
import { Banner, WhyChooseUs, FAQs } from '../../../sections';

import { FaDoorClosed } from 'react-icons/fa';



const DoorPage = () => {

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Doors'} page={'Doors'} />

      <div className='door-page'>

        {/* Door Introduction */}
        <section className="about">

          {/* About Image */}
          <div className="image">
            <div className="sub-image">
              <img src={doorIntro.image.src1} alt={doorIntro.image.alt1} />
            </div>
            <div className="sub-image last">
              <img src={doorIntro.image.src2} alt={doorIntro.image.alt2} />
            </div>
          </div>

          {/* Introduction Content */}
          <div className="content">

            {/* Section Heading */}
            <Heading title={doorIntro.heading} subTitle={doorIntro.sub} sideHeading />

            {/* Description */}
            {doorIntro.description.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Key Features */}
            <div className="about-features">
              {doorIntro.points.map((point, index) => (
                <ul key={index}>
                  <li>
                    <div className='icon'><FaDoorClosed /></div>
                    <span>{point}</span>
                  </li>
                </ul>
              ))}
            </div>

          </div>
        </section>

        {/* Banner Section */}
        <Banner />

        {/* Door Styles */}
        <section className='styles'>

          {/* Section heading */}
          <Heading title={'Door Styles'} subTitle={'Explore Our Door Styles'} />

          <div className='box-container'>

            {/* Map over the doors array to render each door */}
            {doors.map((door) => { 
              return (
                <Style key={door.id} style={door} basePath="Doors" />
              );
            })}

          </div>

        </section>

        {/* Why Choose Us */}
        <WhyChooseUs />

        {/* Doors FAQs */}
        <FAQs faqsContent={doorFaqs} />
 
      </div>

    </>
  )
}

export default DoorPage;